// Public Navigation API
export { DesktopNavigation } from './components/desktop/DesktopNavigation';
export { MobileNavigation } from './components/mobile/MobileNavigation';

// Hooks
export { useDesktopNavHover } from './hooks';

// Re-export types
export type {
  NavigationButton,
  MenuItem,
  NavigationModuleBehavior,
  NavigationStyleOverrides,
  NavigationActionHandler,
  NavigationConfig,
  // Menu item variants
  DividerMenuItem,
  LinkMenuItem,
  ExpandableMenuItem,
  ActionMenuItem,
  // Navigation button variants
  LinkNavigationButton,
  DropdownNavigationButton,
  DividerNavigationButton,
  CustomNavigationButton,
} from './types';
